var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldDisplayButton)?_c('gl-button',{attrs:{"icon":"duo-chat","variant":"confirm","data-testid":"rca-duo-button"},on:{"click":_vm.callDuo}},[_vm._v("\n  "+_vm._s(_vm.s__('Jobs|Troubleshoot'))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }